import React, { useEffect, useRef, useState } from 'react'
import { TitleWrapper, Title } from './ContentStyles'

function Text() {
  const [content, setContent] = useState<string[]>(['welcome to', 'cyberdice'])
  const [changed, setChanged] = useState<boolean>(false)

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setContent(['good luck,', 'have fun'])
          setChanged(true)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  const textRef = useRef<any>(null)
  useOutsideAlerter(textRef)

  return (
    <TitleWrapper initial={changed} ref={textRef}>
      <Title font='Light'>{content[0]}</Title>
      <p className='text'>{content[1]}</p>
    </TitleWrapper>
  )
}

export default Text
